var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('el-button',{staticStyle:{"text-align":"center","width":"150px","margin-top":"40px"},attrs:{"type":"primary"},on:{"click":_vm.toAuth}},[_vm._v("去统一认证系统")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }